import { Third } from "../domain/Third";
import { ThirdRepository, PaginatedThirdsResult } from "../domain/ThirdRepository";
import { query_dispatcher } from "@/api/client";

export class ApiThirdRepository implements ThirdRepository {
  async searchThirds(
    companyId: number,
    userId: number,
    text: string,
    thirdType: 'supplier' | 'customer',
    limit: number = 10,
    offset: number = 0
  ): Promise<PaginatedThirdsResult> {
    const response = await query_dispatcher.dispatch('search.thirds.by.account', {
      company_id: companyId,
      user_id: userId,
      text: text,
      third_type: thirdType,
      limit: limit,
      offset: offset
    });

    return {
      results: response.results,
      total_count: response.total_count
    };
  }
}
